import { SvgIconProps } from '@mui/material';

const NavigationFocusIndicator = (props: SvgIconProps) => {
  return (
    <svg width='21' height='39' viewBox='0 0 21 39' fill='none' data-testid='NavigationFocusIndicatorIcon' {...props}>
      <path
        d='M1.53286 21.745C0.186095 20.5513 0.186096 18.4487 1.53287 17.255L21 -1.2135e-06L21 39L1.53286 21.745Z'
        fill='white'
      />
    </svg>
  );
};

export default NavigationFocusIndicator;
